<template>
  <index />
</template>

<script>
import index from './views/index'

export default {
  name: 'App',
  components: {
    index
  }
}
</script>

<style>
  body{margin:0px;padding:0px;}
  a,a:hover,a:focus{text-decoration:none}
  ul,li{list-style:none;}
  img{border:0px;}
  ul,li,dl,dt,dd,h1,h2,h3,h4,h5,h6,form,p,input{padding:0;margin:0}
  input,button,select,textarea{outline:none}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
